export default {
    mapper: {
        relations: {
            hasMany: {
                trackingNumberImportResult: {
                    foreignKey: 'result_collection_id',
                    localField: 'results',
                },
            },
        },
    },
};
